import React from "react";
import { useSelector } from "react-redux";

import { IoCloseSharp } from "react-icons/io5";
import { ModalDailog, ModalBody } from "./StyledComponents";
import {
  NormalImage,
  Modal,
  ModalContainer,
  Text,
} from "../../StyledComponents";

import { FaExclamationCircle } from "react-icons/fa";
import savedIcon from "../../../Assets/images/saved_successfully.png";

const MessageModal = ({ active, color, onHide }) => {
  // ------------------------------ State and Variables Start--------------------------------------------------- //

  const appointmentData = useSelector(
    (state) => state.Appointments.appointmentData
  );

  // ------------------------------ State and Variables End--------------------------------------------------- //

  return (
    <>
      <Modal show={active} width="100%" height="100%">
        <ModalContainer justifyContent="center">
          <ModalDailog
            width={color === "success" ? "25.5%" : "50%"}
            onClick={onHide}
            show={active}
          >
            <ModalBody
              color={color}
              flexDirection="column"
              padding={color === "success" ? "16px 24px" : "32px"}
            >
              {color === "success" ? (
                <NormalImage
                  loading="lazy"
                  src={savedIcon}
                  height="128px"
                  width="128px"
                />
              ) : color === "danger" ? (
                <FaExclamationCircle />
              ) : (
                <></>
              )}
              <Text
                fontWeight="600"
                fontFamily="'Poppins', sans-serif"
                color="#2E2C34"
                lineHeight="21px"
                margin={color === "danger" ? "8px 0px 8px 12px" : "8px 0px"}
                align={color === "danger" ? "left" : "center"}
                whiteSpace="pre-line"
              >
                {appointmentData["message"]}
              </Text>
            </ModalBody>
          </ModalDailog>
        </ModalContainer>
      </Modal>
    </>
  );
};

export default MessageModal;
